import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError, Observable, BehaviorSubject } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ColetorService {
  private readonly API = `${environment.API}`

  private _finalizarColeta = new BehaviorSubject<string>('');
  finalizarColeta$ = this._finalizarColeta.asObservable();

  constructor(protected http: HttpClient) { }



  save(json) {
    return this.http.post(`${this.API}coletor/cadastrar`, json)
      .pipe(
        catchError(this.handleError),
        take(1)
      )
  }

  // update(idColetor, json){
  //   console.log(json);
  //   return this.http.put(`${this.API}coletor/editar/${idColetor}`, json)
  //   .pipe(
  //     catchError(this.handleError),
  //     take(1)
  // )
  // }

  // getUserByID(idColetor){
  //   return this.http.get(`${this.API}coletor/${idColetor}`)
  //   .pipe(
  //     catchError(this.handleError),
  //     take(1)
  // )
  // }


  protected handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.

      console.error('An error occurred:', error.error.message);
    } else {

      // The backend returned an unsuccessful response code.

      // The response body may contain clues as to what went wrong.

      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }

    // return an observable with a user-facing error message

    return throwError('Something bad happened. Please try again later.');
  }

  sendClose(finalizar: string){
    this._finalizarColeta.next(finalizar);
  }
}
